

import Vue from 'vue';
import Router from 'vue-router';
import Cookies from "js-cookie";
import { msgPageList } from '../utils/constant'
import { encrypt, } from "@/utils/jsencrypt";

Vue.use(Router);

const router = new Router({
  routes: [

    {
      path: '/',
      component: () => import('@/pages/home/index'),
      // component: () => import('@/pages/mgrHome/index'),
      meta: {
        needLogin: true
      },
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: 'home',
          meta: { needLogin: true, tit: '' },
          component: () => import('@/pages/home/home')
        },
        {
          path: '/fee',
          name: 'fee',
          meta: { needLogin: true, tit: '' },
          component: () => import('@/pages/fee/index')
        },
        {
          path: '/my',
          name: 'my',
          component: () => import('@/pages/my/index'),
          meta: {
            needLogin: true,
            tit: ''
          }
        }
      ]
    },
    {
      path: '/mgr',
      component: () => import('@/pages/mgrHome/index'),
      redirect: '/mgrHome',
      meta: {
        needLogin: true
      },
      children: [
        {
          path: '/mgrHome',
          name: 'mgrHome',
          meta: { needLogin: true, tit: '' },
          component: () => import('@/pages/mgrHome/home')
        },
        {
          path: '/mgrCarAllList',
          name: 'mgrCarAllList',
          meta: { needLogin: true, tit: '' },
          component: () => import('@/pages/car/mgrCarAllList/carAllList')
        },
        {
          path: '/mgrCarList',
          name: 'mgrCarList',
          meta: {
            tit: '',
            needLogin: true
          },
          component: () => import('@/pages/car/mgrCarList/index')
        },
        {
          path: '/mgrFreight',
          name: 'mgrFreight',
          meta: {
            tit: '',
            needLogin: true
          },
          component: () => import('@/pages/car/mgrFreight/index')
        },
        {
          path: '/mgrMy',
          name: 'mgrMy',
          component: () => import('@/pages/my/index'),
          meta: {
            needLogin: true,
            tit: ''
          }
        }
      ]
    },
    // 签收人
    {
      path: '/signUser',
      component: () => import('@/pages/signUserHome/index'),
      redirect: '/signUserHome',
      meta: {
        needLogin: true
      },
      children: [
        {
          path: '/signUserHome',
          name: 'signUserHome',
          meta: { needLogin: true, tit: '' },
          component: () => import('@/pages/signUserHome/home')
        },

        {
          path: '/signUserMy',
          name: 'signUserMy',
          component: () => import('@/pages/my/index'),
          meta: {
            needLogin: true,
            tit: ''
          }
        },
        {
          path: '/waitSignList',
          name: 'waitSignList',
          component: () => import('@/pages/signUserHome/WaitSignList'),
          meta: {
            needLogin: true,
            tit: '',
          }
        },

        {
          path: '/signEdit',
          name: 'signEdit',
          component: () => import('@/pages/signUserHome/SignEdit'),
          meta: {
            needLogin: true,
            tit: ''
          }
        },
        {
          path: '/signedPage',
          name: 'signedPage',
          component: () => import('@/pages/signUserHome/SignedPage'),
          meta: {
            needLogin: true,
            tit: ''
          }
        }
      ]
    },
    {
      path: '/pageIndex',
      name: 'pageIndex',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/pageIndex')
    },
    {
      path: '/information',
      name: 'information',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/my/Information')
    },
    {
      path: '/cold',
      component: () => import('@/pages/coldHome/index'),
      meta: {
        needLogin: true
      },
      redirect: '/coldHome',
      children: [
        {
          path: '/coldHome',
          name: 'coldHome',
          meta: { needLogin: true, tit: '' },
          component: () => import('@/pages/coldHome/home')
        },
        {
          path: '/coldFee',
          name: 'coldFee',
          meta: { needLogin: true, tit: '' },
          component: () => import('@/pages/fee/index')
        },
        {
          path: '/coldMy',
          name: 'coldMy',
          component: () => import('@/pages/my/index'),
          meta: {
            needLogin: true,
            tit: ''
          }
        }
      ]
    },

    {
      path: '/playVideo',
      name: 'playVideo',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/home/videoPlayer')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        tit: '',
        keepAlive: true
      },
      component: () => import('@/pages/login/login')
    },
    {
      path: '/reset',
      name: 'reset',
      meta: {
        tit: ''
      },
      component: () => import('@/pages/login/reset')
    },
    {
      path: '/success',
      name: 'success',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/success/success')
    },
    {
      path: '/mgrTransportTask',
      name: 'mgrTransportTask',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/car/mgrTransportTask/index')
    },
    {
      path: '/carAllList',
      name: 'carAllList',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/car/carAllList/carAllList')
    },
    {
      path: '/carMineList',
      name: 'carMineList',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/car/carMineList/carMineList')
    },
    {
      /* 普通运输单详情 */
      path: '/normalDetail',
      name: 'normalDetail',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/car/normalDetail/index')
    },
    {
      /* 冷链运输单详情 */
      path: '/coldchainDetail',
      name: 'coldchainDetail',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/car/coldchainDetail/index')
    },
    {
      path: '/goods',
      name: 'goods',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/car/goods/index')
    },
    {
      path: '/userProtocol',
      name: 'userProtocol',
      meta: {
        tit: '',
        needLogin: false
      },
      component: () => import('@/pages/login/userProtocol')
    },
    {
      path: '/privacyProtocol',
      name: 'privacyProtocol',
      meta: {
        tit: '',
        needLogin: false
      },
      component: () => import('@/pages/login/privacyProtocol')
    },
    {
      path: '/uploadRefuel',
      name: 'uploadRefuel',
      meta: {
        tit: '',
        needLogin: false,
        keepAlive: true
      },
      component: () => import('@/pages/fee/uploadRefuel')
    },
    {
      path: '/addToll',
      name: 'addToll',
      meta: {
        tit: '',
        needLogin: true,
        keepAlive: true
      },
      component: () => import('@/pages/fee/toll/index')
    },
    {
      path: '/address',
      name: 'address',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/address/index')
    },
    {
      path: '/addAddress',
      name: 'addAddress',
      meta: {
        tit: '',
        needLogin: true,
        keepAlive: true
      },
      component: () => import('@/pages/address/AddAddress')
    },
    {
      path: '/oilTollList',
      name: 'oilTollList',
      meta: {
        tit: '',
        needLogin: true,
        keepAlive: true
      },
      component: () => import('@/pages/fee/oilToll/list/index')
    },
    {
      path: '/fuelDetail',
      name: 'fuelDetail',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/fee/oilToll/fuelDetail')
    },
    {
      path: '/tollDetail',
      name: 'tollDetail',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/fee/oilToll/tollDetail')
    },
    {
      path: '/navigation',
      name: 'navigation',
      component: () => import('@/pages/address/navigation'),
      meta: {
        needKeep: false,
        title: ''
      }
    },
    {
      path: '/shippingOrder',
      name: 'shippingOrder',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/coldOrder/shippingOrder')
    },
    {
      path: '/saleOrder',
      name: 'saleOrder',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/coldOrder/saleOrder')
    },
    {
      path: '/signatureOrder',
      name: 'signatureOrder',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/coldOrder/signatureOrder')
    },
    {
      path: '/shipmentTime',
      name: 'shipmentTime',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/coldOrder/shipmentTime')
    },
    {
      path: '/cargoList',
      name: 'cargoList',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/coldOrder/cargoList')
    },
    {
      path: '/deliveryOrder',
      name: 'deliveryOrder',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/coldOrder/deliveryOrder')
    },
    {
      path: '/transportList',
      name: 'transportList',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/coldOrder/transport/list')
    },
    {
      path: '/transportDetail',
      name: 'transportDetail',
      meta: {
        tit: '',
        needLogin: true
      },
      component: () => import('@/pages/coldOrder/transport/detail')
    },
  ]
});

export default router;

router.beforeEach((to, from, next) => {
  //  从小程序传过来的手机号(当前微信的手机号)
  const query = to.query;


  const weixinPhone = query ? query.phone : '';
  const page = query ? query.page : '';


  // 页面不需要做拦截 直接进入后会做登录、查询（从微信通知消息跳转进入）

  // 我要签收页面：/#/signEdit?transportOrderNo=TBSL2024061104000070YSD0137&username=张三&phone=15656897896
  // 已签收页面：/#/signedPage?transportOrderNo=TBSL2024061104000070YSD0137&username=张三&phone=15656897896
  // 待签收列表：/#/waitSignList?active=1&username=张三&phone=15656897896

  // 标题
  if (to.meta.tit) {
    document.title = to.meta.tit;
  }

  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  window.pageXOffset = 0;

  // 检验是否登录
  if (to.meta.needLogin) {
    const token = localStorage.getItem('access_token') && localStorage.getItem('access_token') !== 'undefined'

    if (msgPageList.includes(page)) {
      if (to.path === `/${page}`) {
        next()
      } else {
        if (page === 'normalDetail') {
          next({
            name: page,
            query: {
              ...query,
              active: 'freight'
            }
          });
        } else {
          next({
            name: page,
            query: {
              ...query
            }
          });
        }

      }


    } else if (token) {
      next();
    } else {
      Cookies.set("phone", encrypt(weixinPhone));
      next({
        name: 'login'
      });
    }
  }

  next();
});



// WEBPACK FOOTER //
// ./src/router/index.js